import { MembershipGenderEnum } from 'enums/membership'
import { MembershipType, CurrentMembershipQuery } from 'graphQL/hatostore/generate/operations'
import dayjs from 'dayjs'

export enum MEMBERSHIP_TIER {
  FRIEND = 'FoodPassionFriend',
  BUDDY = 'FoodPassionBuddy',
  FAMILY = 'FoodPassionFamily',
  SOULMATE = 'FoodPassionSoulmate',
}

export enum MEMBERSHIP_PROVIDER {
  FOODPASSION = 'FoodPassion',
  HATOHEART = 'HatoHeart',
}

export enum pointRedemptionFailureReasonTypeEnum {
  InsufficientPoints = 'InsufficientPoints',
  InvalidConditions = 'InvalidConditions',
  Error = 'Error',
  InactiveCampaign = 'InactiveCampaign',
}

export enum pointRedemptionCampaignConditionTypeEnum {
  MAX_REDEMPTIONS = 'MaxRedemptions',
  MAX_REDEMPTIONS_PER_CUSTOMER = 'MaxRedemptionsPerCustomer',
  TIME_OF_DAY = 'TimeOfDay',
}

export const getMembershipCardBgByTier = (tier: MEMBERSHIP_TIER) => {
  switch (tier) {
    case MEMBERSHIP_TIER.FRIEND:
      return `${process.env.PUBLIC_URL}/assets/gon/memberships/gon-member-friend.png`
    case MEMBERSHIP_TIER.BUDDY:
      return `${process.env.PUBLIC_URL}/assets/gon/memberships/gon-member-buddy.png`
    case MEMBERSHIP_TIER.FAMILY:
      return `${process.env.PUBLIC_URL}/assets/gon/memberships/gon-member-family.png`
    case MEMBERSHIP_TIER.SOULMATE:
      return `${process.env.PUBLIC_URL}/assets/gon/memberships/gon-member-soulmate.png`
    default:
      return ''
  }
}

export const getMembershipNameByTier = (tier: MEMBERSHIP_TIER) => {
  switch (tier) {
    case MEMBERSHIP_TIER.FRIEND:
      return 'Friend'
    case MEMBERSHIP_TIER.BUDDY:
      return 'Buddy'
    case MEMBERSHIP_TIER.FAMILY:
      return 'Family'
    case MEMBERSHIP_TIER.SOULMATE:
      return 'Soulmate'
    default:
      return ''
  }
}

export const getMembershipGender = (gender: string) => {
  switch (gender) {
    case MembershipGenderEnum.UNKNOWN:
      return 'form.select.gender.options.none'
    case MembershipGenderEnum.MALE:
      return 'form.select.gender.options.male'
    case MembershipGenderEnum.FEMALE:
      return 'form.select.gender.options.female'
    default:
      return ''
  }
}

export const formatMemberID = (memberID: string) => {
  let newMemberID = ''
  const memberIDArray = memberID.split('')
  memberIDArray.forEach((val, i) => {
    if (i % 4 === 0 && i !== 0) {
      newMemberID += ` ${val}`
    } else {
      newMemberID += val
    }
  })
  return newMemberID
}

interface PointExpiration {
  expirationDate?: string
}
export const isShowExpirationsSection = (pointExpirations: PointExpiration[]) =>
  pointExpirations?.some(
    (pointExpiration) => pointExpiration.expirationDate !== '' && pointExpiration.expirationDate !== null
  )

export const getSubscriptionCoverImage = (
  currentMembership: MembershipType | CurrentMembershipQuery['currentMembership']
) => {
  const coverImage =
    currentMembership?.currentMembershipSubscription?.membershipProgramSubscriptionOption?.coverImage?.resizableURL
  return coverImage ? coverImage.replace('{width}x{height}', '668x1_fmt-png_fit-outside') : ''
}

type PointsExpirations = CurrentMembershipQuery['currentMembership']['pointExpirations']

export const getPointAlmostExpired = (pointExpirarions: PointsExpirations) => {
  const today = dayjs()
  const sixMonthsFromToday = dayjs().add(6, 'month')

  const validPointExpirations = pointExpirarions.filter(
    (item) => dayjs(item.expirationDate).isAfter(today) && dayjs(item.expirationDate).isBefore(sixMonthsFromToday)
  )

  if (validPointExpirations.length === 0) {
    return null
  }

  validPointExpirations.sort((a, b) => {
    const dateA = dayjs(a.expirationDate)
    const dateB = dayjs(b.expirationDate)
    return dateA.diff(dateB)
  })

  return validPointExpirations[0]
}
